import {
  suiUSDT,
  whUSDCe,
  SUI,
  USDC,
  whUSDTe,
  CoinInfo,
  POSITION_CONFIG_INFOS,
  PositionConfigInfo,
  TypeArgument,
  USDY,
  DEEP,
  WAL,
  LBTC,
  wBTC,
  xBTC,
  USDSUI,
} from '@kunalabs-io/kai'

export interface PairInfo<T extends string> {
  coinX: CoinInfo<T>
  coinY: CoinInfo<T>
  configInfos: PositionConfigInfo<string, string, TypeArgument>[]
  frozenConfigInfos: PositionConfigInfo<string, string, TypeArgument>[]
  withdrawOnlyConfigs: PositionConfigInfo<string, string, TypeArgument>[]
  initialAprValue: string
}

function findConfig(configId: string) {
  const config = POSITION_CONFIG_INFOS.find(config => config.configId === configId)
  if (!config) {
    throw new Error(`Config not found for id: ${configId}`)
  }
  return config
}

export const PAIR_INFOS: PairInfo<string>[] = [
  {
    coinX: whUSDTe,
    coinY: USDC,
    configInfos: [],
    frozenConfigInfos: [
      '0xc64d5b0102b85b823d8f8ae5685ea1c153d1c18dcf13a4719798fdf591a9a1b9', // Cetus
    ].map(findConfig),
    withdrawOnlyConfigs: [
      '0x63ded6c35c3f23e471c364ae235216709ca6dd3f83ea763f0be20acc049059d7', // Bluefin
    ].map(findConfig),
    initialAprValue: '9.4% - 97%',
  },
  {
    coinX: whUSDTe,
    coinY: whUSDCe,
    configInfos: [],
    frozenConfigInfos: [
      '0x2d52e5fe8af24f2c750250fca6ce5d595d22287f12d29c6ffbae490f5650478d', // Cetus
    ].map(findConfig),
    withdrawOnlyConfigs: [],
    initialAprValue: '12.5% - 110%',
  },
  {
    coinX: SUI,
    coinY: USDC,
    configInfos: [
      '0xd248b691f00585467010c28f88c8c8b51f9cc0b035dcc36721a06b391d04a11e', // Bluefin 0.175%
      '0xa53edf266e6cf5fce4f54089a6bf925fb802a1a913ac7b675fc7910aa5575856', // Cetus
      '0x4812f9c01753ddb1ecacadd7fe310b6adc7d37b9e00631707cd8860645cb6a39', // Cetus 0.05%
    ].map(findConfig),
    frozenConfigInfos: [
      '0xd6a055c8143f2bb97fdcb34f91ac723708d71473e7dff670a9a2218cc91eab16', // Cetus
    ].map(findConfig),
    withdrawOnlyConfigs: [
      '0x97d0b302207ebe0581a8c8b072fa302a41b8db2fa86baadd750fd1f2fc9cdf92', // Bluefin 0.2%
    ].map(findConfig),
    initialAprValue: '122% - 312%',
  },
  {
    coinX: suiUSDT,
    coinY: USDC,
    configInfos: [
      '0xb1eafb450f32c369e63a90f6609fd8c75f34f818594a67f1a1a1ba707811e767', // Bluefin 0.001%
      '0x93604fae1c21dae08623884f3425c3f8a5c1e02480816ef17d8a194907cf943f', // Cetus 0.001%
    ].map(findConfig),
    frozenConfigInfos: [
      '0x60161ddff3225cad16905d659d938007c3d6baa8f64e27fc6f503cee05d0feca', // Cetus
    ].map(findConfig),
    withdrawOnlyConfigs: [
      '0xf18480cd0b57e0e33542129868712660c27c0b8a60212f587fbe7fde1ba982ef', // Bluefin 0.01%
      '0x888fcd428659608b1adb45790f65dfbac4352150f67d6312f0c0a5f1f9b04692', // Bluefin 0.01% (cetus incident)
    ].map(findConfig),
    initialAprValue: '120% - 266%',
  },
  {
    coinX: USDY,
    coinY: USDC,
    configInfos: [],
    withdrawOnlyConfigs: [],
    frozenConfigInfos: [
      '0x570b46aa3b355305d36e1921c6a5070c76b51e56859b0bde0b6bc0598a89381d', // Cetus
    ].map(findConfig),
    initialAprValue: '151% - 180%',
  },
  {
    coinX: DEEP,
    coinY: SUI,
    configInfos: [
      '0xe844f1deb8c1863de32374a5c1c426d082e57e466e3102a297356b1a8ac06e6b', // Bluefin 0.175%
    ].map(findConfig),
    frozenConfigInfos: [
      '0x92515fe20eb5c0510f42df2ab67f49ca41633571a038edfc180bd83bb9b01011', // Cetus
    ].map(findConfig),
    withdrawOnlyConfigs: [
      '0x3bcfc891da3c64c846cbba27238554fa5b123812b45a8c7f251e27bf7c1fa793', // Bluefin 0.2%
    ].map(findConfig),
    initialAprValue: '130% - 210%',
  },
  {
    coinX: WAL,
    coinY: USDC,
    configInfos: [
      '0x08398431dc7e506cb127c15d69fedbb6965341c0990ce68965c2169d4bad4760', // Bluefin
    ].map(findConfig),
    frozenConfigInfos: [],
    withdrawOnlyConfigs: [],
    initialAprValue: '122% - 312%',
  },
  {
    coinX: WAL,
    coinY: SUI,
    configInfos: [
      '0xfcab5b82478b36fa6d272817f86227fbae0b0288a5a9ac04893a8eb1dafebdd2', // Bluefin
    ].map(findConfig),
    frozenConfigInfos: [],
    withdrawOnlyConfigs: [],
    initialAprValue: '122% - 312%',
  },
  {
    coinX: LBTC,
    coinY: wBTC,
    configInfos: [
      '0x9f51f0136c8e1765c5e355a8cfcc96826d55c0262da160388b90a5c7bbe7c19b', // Bluefin
    ].map(findConfig),
    frozenConfigInfos: [],
    withdrawOnlyConfigs: [],
    initialAprValue: '50% - 80%',
  },
  {
    coinX: xBTC,
    coinY: wBTC,
    configInfos: [
      '0xe9bffee7ecdcc440b7a187e10dc7b990e6deca3708d57c2f09cd93e9b3a23718', // Bluefin
    ].map(findConfig),
    frozenConfigInfos: [],
    withdrawOnlyConfigs: [],
    initialAprValue: '122% - 312%',
  },
  {
    coinX: DEEP,
    coinY: USDC,
    configInfos: [
      '0x55c662d98da03a4a0e60fd1e4fe621c30b09cac49f0e0b800ca0c0f22b9fa6d2', // Bluefin 0.2%
    ].map(findConfig),
    frozenConfigInfos: [],
    withdrawOnlyConfigs: [],
    initialAprValue: '122% - 312%',
  },
  {
    coinX: USDSUI,
    coinY: USDC,
    configInfos: [
      '0x4ca0b323103babe327cb05e55a1aaf068389f85c1d64b29c13d4b016823c634f', // Bluefin 0.01%
      '0x71d0569e29593f93f6f976c61186e2fa0074c4a9133c8cdbb98539dfa9f92249', // Cetus 0.01%
    ].map(findConfig),
    frozenConfigInfos: [],
    withdrawOnlyConfigs: [],
    initialAprValue: '12.5% - 110%',
  },
  {
    coinX: SUI,
    coinY: USDSUI,
    configInfos: [
      '0x8a0dd326411131cbd392bd44a4bfcfe07c3849c72f6218983133f1438a3ff695', // Cetus 0.2%
      '0x2d5d1d10e1b373aa1aea3954df5eabcd84304b18cb472e69ef781f677653ce0f', // Bluefin 0.2%
    ].map(findConfig),
    frozenConfigInfos: [],
    withdrawOnlyConfigs: [],
    initialAprValue: '122% - 312%',
  },
]

export const RECOMMENDED_PAIR_INFOS: PairInfo<string>[] = [
  {
    coinX: suiUSDT,
    coinY: USDC,
    configInfos: [],
    frozenConfigInfos: [POSITION_CONFIG_INFOS[4]],
    withdrawOnlyConfigs: [POSITION_CONFIG_INFOS[5]],
    initialAprValue: '120% - 266%',
  },
  {
    coinX: SUI,
    coinY: USDC,
    configInfos: [],
    frozenConfigInfos: [POSITION_CONFIG_INFOS[2]],
    withdrawOnlyConfigs: [],
    initialAprValue: '122% - 312%',
  },
]
